import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

const SidebarContent = props => {
  const ref = useRef();
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname;

    const initMenu = () => {
      new MetisMenu("#side-menu");
      let matchingMenuItem = null;
      const ul = document.getElementById("side-menu");
      const items = ul.getElementsByTagName("a");
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i];
          break;
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem);
      }
    };
    initMenu();
  }, [props.location.pathname]);

  useEffect(() => {
    ref.current.recalculate();
  });

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Menu")} </li>
            <li>
              <Link to="/dashboard" className="">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboards")}</span>
              </Link>

            </li>
            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bxs-user-detail"></i>
                <span>{props.t("Staff")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/staff">{props.t("Members")}</Link>
                </li>
                <li>
                  <Link to="/roles">{props.t("Roles")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/customers" className="">
                <i className="bx bx-user"></i>
                <span>{props.t("Customers")}</span>
              </Link>
            </li>

            <li>
              <Link to="/subcontractors" className="">
                <i className="bx bx-support"></i>
                <span>{props.t("Subcontractors")}</span>
              </Link>
            </li>

            <li>
              <Link to="/timeoffs" className="">
                <i className="bx bx-bell-off"></i>
                <span>{props.t("Time Off")}</span>
              </Link>
            </li>

            <li>
              <Link to="/routine-schedules" className="">
                <i className="bx bx-calendar"></i>
                <span>{props.t("Routine Schedule")}</span>
              </Link>
            </li>

            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-receipt"></i>
                <span>{props.t("Quotes")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/invoice">{props.t("Invoices")}</Link>
                </li>
                <li>
                  <Link to="/estimate">{props.t("Estimates")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-receipt"></i>
                <span>{props.t("Payroll")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/payrolls">{props.t("List")}</Link>
                </li>
                <li>
                  <Link to="/payrates">{props.t("Payrates")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-briefcase-alt-2"></i>
                <span>{props.t("Projects")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/projects">{props.t("List")}</Link>
                </li>
                <li>
                  <Link to="/projects/geofencing">{props.t("Geofencing")}</Link>
                </li>
              </ul>
            </li>


            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bxs-report"></i>
                <span>{props.t("Report")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/tasks/report">{props.t("Task")}</Link>
                </li>
                <li>
                  <Link to="/timesheets/report">{props.t("Timesheet")}</Link>
                </li>
                <li>
                  <Link to="/payrolls/report">{props.t("Payroll")}</Link>
                </li>
              </ul>
            </li>
            {/* 
            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-server"></i>
                <span>{props.t("Stocks")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/vendors">{props.t("Vendor")}</Link>
                </li>
                <li>
                  <Link to="/products">{props.t("Product")}</Link>
                </li>
                <li>
                  <Link to="/locations">{props.t("Location")}</Link>
                </li>
                <li>
                  <Link to="/purchases">{props.t("Purchase")}</Link>
                </li>
                <li>
                  <Link to="/distributions">{props.t("Distributions")}</Link>
                </li>
              </ul>
            </li>

            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bxs-book-content"></i>
                <span>{props.t("Materials & Category")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/categories">
                    {props.t("Category")}
                  </Link>
                </li>

                <li>
                  <Link to="/materials">
                    {props.t("Material")}
                  </Link>
                </li>
              </ul>
            </li> */}


            <li>
              <Link to="/#" className="has-arrow ">
                <i className="bx bx-user-plus"></i>
                <span>{props.t("Authentication")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">

                <li>
                  <Link to="/users">{props.t("Users")}</Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
